// extracted by mini-css-extract-plugin
export default {"featureBlock":"UPpTj","featureBlockImg":"Hn8yB","featureBlockTitle":"hywHB","featureBlockDescription":"TP_oL","featureBlockLink":"fcI67"};